import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import Icon from '../Icon';
import classnames from 'classnames';

function calculateClass(href, onClick) {
  if (href || onClick) {
    return 'roo-breadcrumb-item-action';
  }

  return '';
}

function renderItem(props, children, text) {
  if (children) {
    return children;
  }

  return /*#__PURE__*/React.createElement("span", _Object$assign({}, props), text);
}

var BreadcrumbItem = function BreadcrumbItem(_a) {
  var children = _a.children,
      text = _a.text,
      href = _a.href,
      icon = _a.icon,
      active = _a.active,
      props = __rest(_a, ["children", "text", "href", "icon", "active"]);

  return /*#__PURE__*/React.createElement("li", {
    className: classnames(calculateClass(href, props.onClick), active ? 'active' : '')
  }, icon ? /*#__PURE__*/React.createElement(Icon, {
    name: icon
  }) : null, href ? /*#__PURE__*/React.createElement("a", _Object$assign({
    href: href
  }, props), children || text) : renderItem(props, children, text));
};

BreadcrumbItem.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func
};
BreadcrumbItem.defaultProps = {
  text: '',
  icon: undefined,
  children: undefined,
  href: undefined,
  active: false,
  onClick: undefined
};
export default BreadcrumbItem;